import styled from 'styled-components'
import { respondTo } from '../../../styles/_respondTo'

export const ContactContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

`

export const H4 = styled.h4`
  color: #E0E4E4;
  font-size: 1.5rem;
  margin-top: 20px;
  margin-bottom: 10px;
  ${respondTo.xs`

  `}

  ${respondTo.sm`
  `}

  ${respondTo.md`
  `}

  ${respondTo.lg`
  font-size: 3rem;
  margin-bottom: 30px;
  `}

  ${respondTo.xl`
  font-size: 3rem;
  margin-bottom: 30px;
  `}
`

export const ImageContact = styled.img`
  width: 30px;
  height: 30px;
  margin-right: 5px;

  ${respondTo.xs`

  `}

  ${respondTo.sm`
  `}

  ${respondTo.md`
  `}

  ${respondTo.lg`
  height: 45px;
    width: 45px;
  `}

  ${respondTo.xl`
  height: 45px;
    width: 45px;
  `}

`

export const AreaImageContact = styled.div`

`